import { Button, Col, Form, Input, Radio, Row } from "antd"
import { Editor } from "./Editor"
import '../style/EmailTemplate.scss'
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { setHeaderName } from "../../../../services/SetHeaderName";


export const CreateEmailTemplate = () => {
    const [form] = Form.useForm();
    const { id } = useParams();
    
    const [editorData, setEditorData] = useState();
    const onChange = (data) => {
        setEditorData(data)
    }
    useEffect(() => {
        if (id) {
            setHeaderName("Edit Template")
        } else {
            setHeaderName("Create Template")
        }
        // to set default data in editor
        // setEditorData("<p>aaa</p>")
    }, []);

    const onFinish = (values) => {
        values.editorData =editorData
    };
    const resetData = () => {
        form.resetFields()
    };

    return (
        <div className="AddEmailTemplate">
            <Form
                name="AddEmailTemplate"
                className="AddEmailTemplateForm"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                    <Col xs={24} md={24} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Template name
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="template_name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Name!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Template Name" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={24} xl={11} xxl={16}>
                        <label className="form-input-label">
                            Template String (Comma Sepreated Variables name)
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="Template String"
                            rules={[
                                { required: true, message: "Please insert Template String!" },
                            ]}
                        >
                            <Input.TextArea placeholder="$name,$Email" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={3} >

                        <label className="form-input-label">
                            User Type
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="user_type"
                            rules={[
                                { required: true, message: "Please Select User Type!" },
                            ]}
                        >
                            <Radio.Group className="mt-2 ">
                                <Radio value="admin"> Admin</Radio>
                                <Radio value="nutrionist">Nutrionist</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={24} xl={11} xxl={24}>
                        <label className="form-input-label">
                            Editor
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Editor onChange={onChange} editorData={editorData} />
                    </Col>
                    <Col span={24} className="text-center">
                        <Button htmlType="submit" className="submit-button b-0 rounded">
                            {id ? 'UPDATE' : 'SAVE'}
                        </Button>
                        <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                            RESET
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>

    )
}
